import request from "../common/request";
import store from "../store";
import {
  IGetColumns,
  INews,
  IConvenience,
  INewsDetails,
  IListFeedBack,
  IHotLine,
  IResponse,
  IConmmen
} from "./types";
class RequestIndex {
  /** 事件循环 */
  private taskList: Array<Function> = [];
  /** 事件定时器 */
  private taskTimer: number = 0;
  constructor() {}
  /** token */
  private get token() {
    return store.state.Token;
  }

  /** appId */
  private get appId() {
    return store.state.appId;
  }
  /** sessionId */
  private get sessionId() {
    return store.state.sessionId;
  }

  /** 父栏目ID */
  private get parentCode() {
    return store.state.parentCode;
  }

  /** 开始循环执行事件 */
  private task() {
    this.taskTimer = setInterval(() => {
      this.taskList.forEach(item => {
        item.apply(this);
      });
    }, 10000);
  }

  /** 将事件记录到事件循环 */
  private addTask(func: Function) {
    const timer = setInterval(() => {
      if (this.token) {
        func.apply(this);
        clearInterval(timer);
      }
    }, 100);
    this.taskList.push(func);
  }
  /**
   * 发起网络请求
   * @param url 请求地址
   * @param parm 请求参数
   * @param isShow 是否显示Loading
   */
  private send(
    url: string,
    parms: object = {},
    isShow: boolean = false
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      request
        .post(url, parms)
        .then(res => {
          this.finally();
          resolve(res);
        })
        .catch(erro => {
          this.finally();
          reject(erro);
        });
    });
  }

  /**
   * Promise的finally回调，在ios 10.1版本不支持，故使用此方式
   */
  private finally() {}

  /**
   * 获取栏目
   * @param parentCode 父栏目ID
   */
  public getColumns(parentCode: string): Promise<IGetColumns> {
    return this.send("/getColumns.html", { appId: this.appId, parentCode });
  }

  /**
   * 获取新闻列表
   * @param isCarousel 是否轮播
   * @param columnId 栏目ID
   * @param lastId 翻页时最后一条数据
   * @param lastSortNo 翻页时最后一条数据的排序号
   * @param lastOnlineTime 翻页时最后一条数据的上线时间
   */
  public getNews(
    isCarousel: boolean,
    columnId: string,
    lastId?: number,
    lastSortNo?: number,
    lastOnlineTime?: string
  ): Promise<INews> {
    return this.send("/info/news.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      isCarousel,
      columnId,
      lastId,
      lastSortNo,
      lastOnlineTime
    });
  }

  /**
   * 获取新闻详情
   * @param infoClassifyId 新闻的infoClassifyId
   */
  public getNewsDetails(infoClassifyId: string): Promise<INewsDetails> {
    return this.send("/info/getActNewsInfo.html", { infoClassifyId });
  }

  /**
   * 便民信息接口
   * @param columnsId 栏目ID
   */
  convenience(columnsId: string): Promise<IConvenience> {
    return this.send("/convenience.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      columnsId
    });
  }

  /**
   * 获取留言列表
   * @param lastId 列表最后一条的id
   */
  getListFeedBack(lastId?: number): Promise<IListFeedBack> {
    return this.send("/listFeedBack.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      lastId: lastId
    });
  }

  /**
   * 保存留言
   * @param title 标题
   * @param images 图片
   * @param content 内容
   */
  saveFeedBack(
    title: string,
    images: string,
    content: string
  ): Promise<IResponse> {
    return this.send("/saveFeedBack.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      title,
      images,
      content
    });
  }

  /**
   * 获取热线
   */
  hotline(): Promise<IHotLine> {
    return this.send("/hotline.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      hotlineTypeId: ""
    });
  }

  /**
   * 获取留言
   * @param sourceId 源ID
   * @param lastCreateTime 最后一条记录的创建时间
   * @param lastReplyId 最后一条记录的评论ID
   */
  comment(
    sourceId: number,
    lastCreateTime?: string,
    lastReplyId?: number
  ): Promise<IConmmen> {
    return this.send("/comments.html", {
      appId: this.appId,
      sessionId: this.sessionId || "q323",
      token: this.token,
      sourceType: 1,
      sourceId: sourceId,
      lastCreateTime: lastCreateTime,
      lastReplyId: lastReplyId
    });
  }
}
export default new RequestIndex();
